export type TShopifyTag = { name: string }

export const EXCLUDED_AFFINITY_TAGS = new Set<string>([
  'gs_violation',
  'gs_violation_dynamic',
  'Controlado',
  'Controlados344',
  'Tarja Vermelha',
  'Tarja Preta',
  'Desconto de Laboratório',
  'Medicamento',
  'Medicamentos',
  'Medicamento Genérico',
  'Medicamento Similar',
  'Medicamentos Controlados',
  'Medicamento Novo',
  'Medicamento Similar Intercambiável',
  'Medicamento Específico',
  'Medicamento Biológico',
  'Medicamento Referência'
])

export function pickAffinityTag(shopifyTags: TShopifyTag[] | null | undefined): string | undefined {
  return shopifyTags?.find((tag) => tag?.name && !EXCLUDED_AFFINITY_TAGS.has(tag.name))?.name
}
